import { Component, OnInit, ViewChild, inject } from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow,
} from '@angular/material/table';
import { endOfMonth, format, startOfMonth, subMonths } from 'date-fns';
import {
  ChartParams,
  ChartsService,
  SuccessfulSoftCase,
} from 'src/app/services/charts/charts.service';
import { PayeeFormFieldComponent } from '../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeDatepickerComponent } from '../../../../shared/payee-form-fields/payee-datepicker/payee-datepicker.component';
import { PayeeButtonComponent } from '../../../../shared/payee-buttons/payee-button/payee-button.component';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'app-soft-paid',
  templateUrl: './soft-paid.component.html',
  styleUrls: ['./soft-paid.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    PayeeFormFieldComponent,
    PayeeDatepickerComponent,
    PayeeButtonComponent,
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    JsonPipe,
  ],
})
export class SoftPaidComponent implements OnInit {
  private chartsService = inject(ChartsService);
  private fb = inject(FormBuilder);

  readonly filterForm = this.fb.group({
    from_date: this.fb.control<Date>(startOfMonth(subMonths(new Date(), 1)), {
      validators: Validators.required,
      nonNullable: true,
    }),
    to_date: this.fb.control<Date>(endOfMonth(subMonths(new Date(), 1)), {
      validators: Validators.required,
      nonNullable: true,
    }),
  });

  readonly dataSource = new MatTableDataSource<SuccessfulSoftCase>();
  readonly displayedColumns: (keyof SuccessfulSoftCase)[] = [
    'client_name',
    'client_country',
    'client_postcode',
    'client_settlement',
    'client_street',
    'client_tax_number',
    'user_email',
    'debtor_name',
    'client_id',
    'case_id',
    'claims',
    'currency_iso',
    'closed_at',
    'state',
    'product',
    'product_type',
    'partner',
  ];

  @ViewChild(MatSort) set sort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  get from_date() {
    return this.filterForm.controls.from_date;
  }
  get to_date() {
    return this.filterForm.controls.to_date;
  }

  async ngOnInit() {
    await this.getCharts();
  }

  async getCharts() {
    const { from_date, to_date } = this.filterForm.getRawValue();

    const params: ChartParams = {
      from_date: format(from_date, 'yyyy-MM-dd'),
      to_date: format(to_date, 'yyyy-MM-dd'),
    };

    const result = await this.chartsService.getSuccessfulSoftCases(params);
    this.dataSource.data = result.data;
  }
}
